<template>
    <main id="yagish_about">
        <section class="hero_block">
            <h2 class="h2_other renew2_wrapper">유용한 정보</h2>
        </section>

        <section id="article" class="article">
            <div class="article__hero">
                <h1>이력서 경력사항 작성법 완전 정리｜경력 기술서 예시&직무별 팁</h1>
                <img src="/kr/resume/static/img/article/article_guide_mv03.jpg"
                    alt="이력서 경력사항 작성법 완전 정리｜경력 기술서 예시 & 직무별 팁" class="mvimg">

                <p>
                    이력서에서 경력사항은 인사 담당자가 가장 먼저 확인하는 핵심 항목입니다. 단순히 어디서 일했는지를 나열하는 것이 아니라, 어떤 성과를 냈고 어떤 역량을 갖추었는지를 효과적으로
                    보여줘야 서류 통과 확률이 높아집니다.
                </p>
            </div>

            <div class="article__contents">
                <h2>1. 이력서에서 경력사항의 중요성</h2>
                <p>
                    이력서에서 경력사항은 단순한 항목이 아닌, 지원자의 실무 역량과 직무 적합성을 가장 직접적으로 보여주는 부분입니다. 특히 경력직 채용의 경우, 학력보다 경력을 더 비중 있게 보는
                    경우가 많기 때문에, 이 항목을 얼마나 전략적으로 작성하느냐에 따라 서류 통과 여부가 갈릴 수 있습니다.
                </p>

                <h3>왜 경력사항이 가장 먼저 검토되는가?</h3>
                <p>
                    인사 담당자는 수많은 이력서를 빠르게 검토해야 하므로, 지원자가 어떤 회사에서 어떤 일을 했는지를 먼저 확인합니다. 이를 통해 해당 직무와 얼마나 연관된 경험이 있는지, 즉 바로
                    투입 가능한 인재인지 판단합니다. 경력사항이 명확하고 눈에 띄게 정리되어 있다면, 다음 항목도 더 관심 있게 읽히게 됩니다.
                </p>

                <h3>인사 담당자가 경력란에서 확인하는 핵심 포인트</h3>
                <p>
                    성과 및 기여도: 단순 참여가 아닌, 구체적인 성과가 있었는지
                    <br>
                    경력의 연속성: 경력 공백이나 잦은 이직 여부
                    <br>
                    조직 규모 및 역할: 어떤 환경에서 어떤 수준의 책임을 맡았는지
                    <br>
                    표현 방식: 지원자의 글쓰기 스타일과 논리적 구성력
                    <br>
                    이처럼 경력사항은 단순한 이력 나열이 아니라, 자신의 강점을 설득력 있게 어필하는 핵심 무기가 되어야 합니다.
                </p>

                <h2>2. 기본적인 경력사항 작성 방법</h2>
                <p>경력사항은 단순히 근무 이력을 나열하는 공간이 아닙니다. 회사명, 직무명, 근무기간, 주요 업무, 성과를 체계적이고 명확하게 정리해야 채용 담당자가 빠르게 핵심을 파악할 수
                    있습니다. 아래 항목들을 기준으로 기본 작성법을 정리해드립니다.</p>

                <h3>경력은 최신순으로, 구체적으로</h3>
                <p>
                    가장 최근에 근무한 회사부터 역순으로 작성하는 것이 원칙입니다. 이는 채용 담당자가 지원자의 최신 업무 경험을 먼저 확인할 수 있도록 돕기 위함입니다. 또한 단순히 ‘무엇을
                    했다’가 아닌, 얼마나, 어떻게 했는지를 구체적으로 작성해야 신뢰도를 높일 수 있습니다.
                </p>

                <p>
                    예시:
                    <br>
                    ㈜ABC컴퍼니 / 마케팅팀 / 대리 | 2021.05 ~ 2023.08
                </p>

                <p>
                    SNS 채널 운영 및 콘텐츠 기획
                    <br>
                    월 평균 리드 30% 증가
                    <br>
                    팀 내 협업 프로젝트 리더 수행
                </p>

                <h3>회사명, 직무, 근무기간의 표기 기준</h3>
                <p>
                    회사명은 약칭보다는 공식 명칭을 사용
                    <br>
                    직무명은 모호한 표현보다 실제 업무와 맞는 용어로
                    <br>
                    근무기간은 연도 및 월까지 정확히 기입 (예: 2020.01 ~ 2022.06)
                    <br>
                    특히, 프리랜서 또는 프로젝트 단위 업무는 근무 형태를 따로 명시하는 것이 좋습니다.
                    <br>
                    예: “프리랜서 디자이너 | 2022.03 ~ 2022.12”
                </p>

                <h3>정규직, 계약직, 프리랜서의 작성 방식 차이</h3>
                <p>
                    근무 형태에 따라 명확히 구분해서 작성하면 좋습니다.
                    <br>
                    정규직: 별도 표기 없이 기본 형태로 작성
                    <br>
                    계약직: 직무명 뒤에 (계약직) 또는 별도 표기
                    <br>
                    프리랜서/아르바이트: 프로젝트명 또는 클라이언트명과 함께 기술
                    <br>
                    이러한 구분은 지원자의 경험에 대한 신뢰도를 높이고, 오해를 줄여줍니다.
                </p>

                <h3>퇴사 사유는 꼭 써야 할까?</h3>
                <p>
                    이력서에는 퇴사 사유를 굳이 작성하지 않아도 됩니다. 하지만 이직이 잦거나 경력 공백이 있을 경우 면접에서 질문이 들어올 수 있으므로, 사전에 간단한 설명을 준비해두는 것이
                    좋습니다. 만약 회사 사정에 따른 퇴사(예: 구조조정, 계약 만료 등)였다면, 별도로 작성해도 무방합니다.
                </p>

                <h2>3. 경력 기술서 작성 요령과 예시</h2>
                <p>
                    이력서의 경력사항이 기본 정보 중심의 요약이라면, 경력 기술서는 자신의 성과와 역할을 상세하게 설명하는 확장된 문서입니다. 특히 경력직 지원 시, 경력 기술서의 완성도는 서류
                    통과율에 큰 영향을 미칩니다. 아래는 효과적인 경력 기술서 작성 요령과 실전 예시입니다.
                </p>

                <h3>STAR 기법으로 핵심 성과 전달하기</h3>
                <p>
                    경력 기술서는 단순한 업무 나열이 아니라, S.T.A.R 기법을 활용해 이야기를 구조화하는 것이 좋습니다.
                    <br>
                    S (Situation): 어떤 상황에서
                    <br>
                    T (Task): 어떤 과제를 맡았고
                    <br>
                    A (Action): 어떤 행동을 했으며
                    <br>
                    R (Result): 어떤 결과를 얻었는가
                </p>

                <p>
                    예시:
                    <br>
                    SNS 마케팅 성과 향상 프로젝트
                    <br>
                    인스타그램 계정 운영 초기 단계에서 콘텐츠 노출 부족 문제가 있었고, 이를 개선하기 위해 타겟 고객 분석 및 콘텐츠 A/B 테스트를 진행함. 그 결과 3개월 내 팔로워 수 200%
                    증가 및 월 리드 30% 증가 달성.
                    <br>
                    이처럼 스토리텔링 방식으로 경험을 정리하면, 신뢰도와 이해도를 동시에 높일 수 있습니다.
                </p>

                <h3>숫자와 구체적 결과 중심으로 서술</h3>
                <p>
                    성과를 나타낼 때는 수치와 지표를 활용하면 훨씬 강력한 인상을 줄 수 있습니다.
                    <br>
                    “고객 만족 향상” → “고객 만족도 15% 향상”
                    <br>
                    “매출 증가에 기여” → “6개월 내 매출 25% 증가 달성”
                    <br>
                    이러한 수치는 객관적인 성과를 보여주고, 지원자의 문제 해결 능력과 실행력을 효과적으로 전달합니다.
                </p>

                <h3>역할과 책임, 협업 사례 기재 팁</h3>
                <p>
                    팀 내에서의 역할, 프로젝트 내 주요 책임, 타 부서와의 협업 경험 등은 지원자의 실무 적응력을 평가하는 데 중요한 요소입니다. 아래 내용을 포함하면 좋습니다:
                    <br>
                    담당했던 주요 업무 항목
                    <br>
                    리드 혹은 주도한 프로젝트 유무
                    <br>
                    협업 부서 및 커뮤니케이션 방식
                    <br>
                    도전 과제와 극복 방법
                    <br>
                    예시 문장:
                    <br>
                    제품 기획 단계에서 UX 디자이너 및 개발팀과의 협업을 통해 프로토타입을 제작하고, 사용자 테스트를 통해 기능 개선안을 도출함.
                </p>

                <h3>직무별 경력 기술서 예시 (마케팅, 개발, 디자인 등)</h3>

                <p>
                    마케팅
                    <br>
                    콘텐츠 기획 및 운영, 광고 캠페인 분석, 성과 리포트 작성 등
                </p>

                <p>
                    개발
                    <br>
                    사용 기술 스택, 프로젝트 규모, 유지보수 및 협업 도구 경험 등
                </p>

                <p>
                    디자인
                    <br>
                    담당했던 플랫폼(UI/UX), 디자인 툴 사용 능력, 프로젝트 성과 중심
                </p>

                <p>
                    각 직무에 맞는 언어와 방식으로 구체적인 결과 중심으로 작성하는 것이 핵심입니다.
                </p>

                <h2>4. 자주 하는 실수와 피해야 할 표현</h2>
                <p>
                    경력사항을 작성할 때 자칫 실수하기 쉬운 부분들이 있습니다. 특히 채용 담당자는 경력란에서 작은 표현 하나만으로도 신뢰 여부를 판단하기 때문에, 잘못된 표현이나 불명확한 정보는
                    주의가 필요합니다. 이 섹션에서는 자주 하는 실수와 피해야 할 표현들을 구체적으로 정리해 드립니다.
                </p>

                <h3>모호하고 추상적인 표현</h3>
                <p>
                    "성실히 일했습니다", "열심히 노력했습니다" 같은 표현은 추상적이고 개인적인 느낌만 줄 뿐, 실질적인 정보 전달이 되지 않습니다. 대신 무엇을 했고, 어떤 결과가 있었는지
                    구체적으로 작성해야 합니다.
                </p>

                <p>
                    예시 (피해야 할 표현):
                    <br>
                    다양한 프로젝트를 경험했습니다.
                    고객과 원활한 소통을 했습니다.
                </p>

                <p>
                    개선 예시:
                    <br>
                    총 5건의 온라인 캠페인 기획 및 운영, 그중 2건에서 CTR 10% 이상 달성
                    고객 문의 대응 시간 평균 30% 단축 및 만족도 90% 이상 유지
                </p>


                <h3>과장되거나 사실과 다른 정보</h3>
                <p>
                    실제보다 성과를 과장하거나, 맡지 않았던 일을 주도했다고 표현하는 것은 매우 위험합니다. 면접에서 구체적인 질문이 나왔을 때 답변을 못 하거나, 모순이 생기면 바로 신뢰를 잃게
                    됩니다.
                </p>

                <p>
                    또한, 팀 성과를 개인 성과처럼 작성하는 것도 주의해야 합니다. 본인의 기여도를 분명히 구분지어야 하며, “~에 참여” “~를 담당” 등의 표현으로 정확하게 전달하는 것이
                    좋습니다.
                </p>

                <h3>복잡한 문장과 나열식 문장의 한계</h3>
                <p>
                    많은 업무 경험을 한꺼번에 보여주기 위해 긴 문장이나 과도한 나열로 작성하는 경우, 오히려 가독성을 떨어뜨리고 핵심 전달이 어려워질 수 있습니다. 각 업무의 목적과 결과를 짧은
                    단락 또는 리스트 형식으로 정리하는 것이 좋습니다.
                </p>

                <p>
                    예시:
                    <br>
                    SNS 기획 운영, 콘텐츠 제작, 영상 편집, 광고 성과 분석, 인플루언서 제휴 등 다양한 업무를 맡아 브랜드 성장을 도왔습니다.
                </p>

                <p>
                    개선 예시:
                    <br>
                    SNS 콘텐츠 주 3회 기획 및 제작
                </p>

                <p>
                    월별 광고 성과 리포트 작성 및 CTR 분석
                    <br>
                    인플루언서 마케팅 제휴 10건 진행 및 팔로워 수 150% 증가
                </p>

                <h3>경력 공백이 있는 경우 대처 방법</h3>
                <p>
                    경력 공백이 있다면, 이를 숨기기보다 정확히 인정하고 그동안의 활동을 간단히 설명하는 것이 좋습니다. 예를 들어, 학업, 자격증 준비, 육아, 개인 프로젝트, 프리랜서 활동 등을
                    구체적으로 밝히면 부정적 인상을 줄일 수 있습니다.
                </p>

                <p>
                    예시:
                    <br>
                    2022.01 ~ 2022.12 | 경력 공백 기간 – UX/UI 디자인 교육 이수 및 포트폴리오 제작
                    이처럼 솔직하면서도 생산적인 활동을 강조하면, 오히려 자기주도적인 인상을 줄 수 있습니다.
                </p>

                <h2>5. 마무리 요약 및 체크리스트</h2>
                <p>
                    경력사항은 이력서에서 가장 핵심적인 항목 중 하나이며, 지원자의 실무 역량과 직무 적합성을 직접적으로 보여주는 공간입니다. 단순히 근무 이력을 나열하는 것이 아니라, 구체적인
                    성과, 역할, 그리고 결과 중심의 표현을 통해 신뢰도와 설득력을 높여야 합니다.
                    <br>
                    경력 기술서는 특히 경력직 지원자에게 중요하며, STAR 기법과 수치 기반의 설명, 협업 경험 등을 통해 내용을 구조화하는 것이 효과적입니다. 또한 모호한 표현이나 과장된 성과는
                    지양하고, 있는 그대로의 경험을 논리적이고 깔끔하게 정리하는 자세가 필요합니다.
                    <br>
                    경력 공백이 있더라도 솔직하게 인정하고 그 시간을 어떻게 활용했는지 보여주는 것이 오히려 긍정적으로 작용할 수 있습니다.
                </p>

            </div>

            <div class="articlelist">
                <a href="/kr/resume/article" class="articlelist__link">기사 목록</a>
            </div>

        </section>
    </main>
</template>

<style lang="css" src="@/assets/css/renew_info.css"></style>
<style lang="scss" src="@/assets/scss/article/article.scss"></style>
<script>
export default {
    created: function () {
    }
}
</script>